module.exports = __webpack_public_path__ + "media/images/vp/tutorialpopup.2-1c8b15a17c1d0b84acebbc7986ead12f.svg";